// extracted by mini-css-extract-plugin
export default {"item":"totalDesignCounts_item__APh4q"};